import { IRegulation } from '../../contracts/amendment.contract';

const regulationFilterText = (userInputText: string, regulations: IRegulation[]): IRegulation[] => {
    return userInputText
        ? regulations.filter(
              (reg: IRegulation) => reg.RegulationName.toLowerCase().includes(userInputText.toLowerCase()) || reg.Amendments[0].Description.toLowerCase().includes(userInputText.toLowerCase())
          )
        : regulations;
};

export default regulationFilterText;
